import React, { useMemo, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { IImageModuleProps } from '../../../Post/modules/Image'

const FBProfileImage: React.FC<IImageModuleProps> = (props) => {
  const useStyles = makeStyles((theme: Theme) => ({
    img: {
      borderRadius: '50%',
      height: '40px',
      width: '40px',
      margin: '13px 13px 20px',
    },
  }))
  const classes = useStyles()
  // eslint-disable-next-line no-unused-vars
  const { t } = useTranslation()

  const [imageSrc, setImageSrc] = useState<string>('/src/shared/assets/images/defaultFacebookProfileImage.jpg')

  // Only test and load the image when props.data changes
  useEffect(() => {
    if (props.data) {
      const img = new Image()
      
      img.onload = () => {
        setImageSrc(props.data!)
      }
      
      img.onerror = () => {
        setImageSrc('/src/shared/assets/images/defaultFacebookProfileImage.jpg')
      }

      img.src = props.data
    } else {
      setImageSrc('/src/shared/assets/images/defaultFacebookProfileImage.jpg')
    }
  }, [props.data])

  return (
    <>
      <img className={classes.img} src={imageSrc} />
    </>
  )
}

export default React.memo(FBProfileImage)
